{
  "StatvaluestypeLabel": "Output per i campi percentuale, data\/ora e durata:",
  "StatvaluestypeBothOptionLabel": "[Valori doppi (formattato + grezzo)]",
  "StatvaluestypeMainOptionLabel": "Solo valore di visualizzazione formattato (testo)",
  "StatvaluestypeAlternateOptionLabel": "Solo valore grezzo (per l'uso di grafici e formule)",
  "CSVExportFormat_SectionHeader": "Formato di esportazione CSV",
  "CSVExportFormat_SectionPara": "È possibile regolare il modo in cui vengono generati i valori statistici di percentuale, data\/ora e durata nei report esportati in formato CSV.",
  "NAME": "CSVExportFormat"
}